import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finance-reports-help',
  templateUrl: './finance-reports-help.component.html',
  styleUrls: ['./finance-reports-help.component.css']
})
export class FinanceReportsHelpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
